import { render, staticRenderFns } from "./cover-background.vue?vue&type=template&id=518be3eb&lang=pug&"
import script from "./cover-background.vue?vue&type=script&lang=js&"
export * from "./cover-background.vue?vue&type=script&lang=js&"
import style0 from "./cover-background.vue?vue&type=style&index=0&id=518be3eb&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports